export function playwrightTestIdentity(title: string) {
  const titlePath = title.split(' › ').filter(part => part.trim())
  return {
    testName: titlePath.at(-1) ?? title,
    testContext: titlePath.slice(0, -1).join(' › '),
  }
}

export function playwrightErrorText(error: string) {
  // Submitted Playwright errors may contain terminal formatting sequences.
  return error.replace(/\u001b\[[0-?]*[ -/]*[@-~]/g, '').trim() || 'No error details submitted.'
}
